import { Spinner } from "@cmsgov/ds-medicare-gov";
import Div from "./div";

export const FullPageSpinner = () => {
    return (
        <Div isContainer paddingy={4}>
            <div
                className='ds-u-display--flex ds-u-justify-content--center ds-u-align-items--center'
                style={{ height: '100%' }}
            >
                <Spinner size='big' />
            </div>
        </Div>
    );
}